var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitResponse.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.randomNumber)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }